import React from 'react';
import { motion } from 'framer-motion';
import { experiences } from '../../data/portfolioData';

export default function ExperienceTimeline() {
  return (
    <section id="experience" className="mx-auto w-full max-w-7xl px-4 py-20 sm:px-6 lg:px-10">
      <div className="mb-10">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-cyan-300">Career Path</p>
        <h2 className="font-display text-3xl font-bold text-white sm:text-5xl">Experience Timeline</h2>
      </div>

      <div className="relative">
        <div className="absolute left-3 top-0 h-full w-px bg-gradient-to-b from-cyan-300 via-violet-400 to-cyan-300/20 md:left-1/2" />

        <div className="space-y-10">
          {experiences.map((item, index) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.45 }}
              className={`relative md:w-1/2 ${index % 2 === 0 ? 'md:pr-8' : 'md:ml-auto md:pl-8'}`}
            >
              <span className={`absolute top-6 h-3 w-3 rounded-full border border-cyan-200 bg-cyan-400 shadow-glow ${index % 2 === 0 ? 'left-[6px] md:-right-[7px] md:left-auto' : 'left-[6px] md:-left-[7px]'}`} />

              <div className="glass-card ml-8 md:ml-0">
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-cyan-300">{item.period}</p>
                <h3 className="mt-2 font-display text-xl font-bold text-white">{item.title}</h3>
                <p className="text-sm font-semibold text-slate-200">{item.company}</p>
                <p className="mt-3 text-sm text-slate-300">{item.summary}</p>
                <ul className="mt-4 space-y-2 text-sm text-slate-400">
                  {item.points.map((point) => (
                    <li key={point} className="flex gap-2">
                      <span className="mt-2 h-1.5 w-1.5 rounded-full bg-cyan-300" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
